import React, { Component } from 'react'
import { connect } from 'react-redux'
import { History } from 'history'

import { createAdmin, updateAdminBadges } from './adminActions'
import { fetchOrganizations } from '../../actions/organizationActions'
import { displayNotification } from '../../actions/notificationsActions'
import AdminForm, { trimAgentId } from './adminForm'
import Breadcrumb from '../../components/Breadcrumb'
import { selectCurrentUserBadges } from '../../reducers'

export type Callback<T = void> = (...args: any) => T

export interface Props {
  createAdmin: Callback<Promise<any>>
  updateAdminBadges: Callback<Promise<any>>
  fetchOrganizations: Callback<Promise<any>>
  displayNotification: Callback
  organizations: any[]
  canAssignSuperuser: boolean
  history: History
}

export class AdminCreate extends Component<Props> {
  static displayName = 'AdminCreate'

  componentWillMount() {
    this.props.fetchOrganizations()
  }

  onSubmit = (values) => {
    const { history, createAdmin, updateAdminBadges, displayNotification } =
      this.props
    const { badges, calltoolsAgentId, ...rest } = values
    const profileFields = trimAgentId(calltoolsAgentId)
      ? { ...rest, calltoolsAgentId: trimAgentId(calltoolsAgentId) }
      : rest
    const selectedBadges = Array.isArray(badges) ? badges : []

    return createAdmin(profileFields).then((id) => {
      const goToAdmin = () => history.push({ pathname: `/admins/${id}` })

      if (!selectedBadges.length) {
        return goToAdmin()
      }

      return updateAdminBadges(
        id,
        selectedBadges,
        (admin) => `Created admin and assigned badges: ${admin.name}`
      ).then(goToAdmin, () => {
        // Create succeeded but the badge request failed: the admin already
        // exists, so resubmitting this form would not help. Land on their
        // profile, where badges can be re-applied, and say which step failed.
        displayNotification(
          'Admin was created, but assigning badges failed. Re-apply the badges from their profile.',
          'error',
          10000
        )
        goToAdmin()
      })
    })
  }

  onCancel = () => {
    this.props.history.goBack()
  }

  render() {
    const { organizations, canAssignSuperuser } = this.props
    const levels = [
      { label: 'Admins', path: '/admins' },
      { label: 'New', path: '' },
    ]
    return (
      <>
        <Breadcrumb levels={levels} />
        <div className="user-profile-create">
          <AdminForm
            title="Create Admin"
            onSubmit={this.onSubmit}
            cancel={this.onCancel}
            organizations={organizations}
            showBadges
            requireOrganization
            canAssignSuperuser={canAssignSuperuser}
          />
        </div>
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  organizations: (state.organizations && state.organizations.all) || [],
  canAssignSuperuser: (selectCurrentUserBadges(state) || []).includes(
    'SUPERUSER'
  ),
})
export default connect(mapStateToProps, {
  createAdmin,
  updateAdminBadges,
  fetchOrganizations,
  displayNotification,
})(AdminCreate)
